import { createAsyncThunk } from '@reduxjs/toolkit';
import { atsJobsActions } from './atsJobsReducer';

// todo: need to update these, for now added some sample
const actionsConfig = {
  createJob: {
    method: 'post',
    endpoint: '/ats_jobs',
    thunkName: 'createJob',
    reducerName: 'createJob',
    responseKey: 'data',
  },
  updateJob: {
    method: 'put',
    endpoint: '/ats_jobs/:jobId',
    thunkName: 'updateJob',
    reducerName: 'updateJob',
  },
  cloneJob: {
    method: 'post',
    endpoint: '/ats_jobs/:jobId/clone',
    thunkName: 'cloneJob',
    reducerName: 'cloneJob',
    responseKey: 'data',
  },
  createOffice: {
    method: 'post',
    endpoint: '/ats_offices',
    thunkName: 'createOffice',
    reducerName: 'createOffice',
    responseKey: 'data',
  },
  getAllJobs: {
    method: 'get',
    endpoint: '/ats_jobs',
    thunkName: 'getAllJobs',
    reducerName: 'getAllJobs',
    responseKey: 'data',
  },
  archiveJob: {
    method: 'put',
    endpoint: '/ats_jobs/:jobId/archive',
    thunkName: 'archiveJob',
    reducerName: 'archiveJob',
    responseKey: 'data',
  },
  closeJob: {
    method: 'put',
    endpoint: '/ats_jobs/:jobId/close',
    thunkName: 'closeJob',
    reducerName: 'closeJob',
  },
  reopenJob: {
    method: 'put',
    endpoint: '/ats_jobs/:jobId/reopen',
    thunkName: 'reopenJob',
    reducerName: 'reopenJob',
  },
};

function replacePathParameters(endpoint, pathParams) {
  if (!pathParams || typeof pathParams !== 'object') {
    // Handle the case where pathParams is undefined, null, or not an object
    return endpoint;
  }

  const regex = new RegExp(`:${Object.keys(pathParams).join('|')}`, 'g'); // Create a global regex
  return endpoint.replace(regex, (match) => pathParams[match.slice(1)]); // Use a callback for replacement
}

// Reads have no cancellation, so two in flight for the same key resolve in
// whatever order the network returns them and the slower one wins. Stamp each
// read and let only the newest write to the store.
const latestReadId = {};

const apiAction = async (currentAction, config, args) => {
  const [dispatch, _getState, extraArgument] = args;
  const { atsHttp } = extraArgument;
  const { endpoint, method, reducerName: key, responseKey } = currentAction;
  const {
    requestConfig = {},
    isBackground = false,
    pathParams = {},
    onSuccess,
  } = config;
  const { setLoadingState, setApiData } = atsJobsActions;

  const isRead = method === 'get';
  const readId = isRead
    ? (latestReadId[key] = (latestReadId[key] || 0) + 1)
    : 0;
  const isSuperseded = () => isRead && latestReadId[key] !== readId;

  // If isBackground skip setting loading state to avoid showing loaders
  if (!isBackground) {
    dispatch(setLoadingState({ key, isLoading: true }));
  }
  const updatedEndpoint = replacePathParameters(endpoint, pathParams);
  try {
    const result = await atsHttp[method](updatedEndpoint, { ...requestConfig });
    const response = responseKey ? result[responseKey] : result;
    if (isSuperseded()) return response;
    dispatch(
      setApiData({
        key,
        data: response,
        status: result?.status,
        isLoading: false,
        errors: result?.errors,
        flash: result?.flash,
      })
    );
    // Call onSuccess if provided
    if (onSuccess && typeof onSuccess === 'function') {
      onSuccess?.(result);
    }
    return response;
  } catch (error) {
    if (!isSuperseded()) {
      dispatch(setApiData({ key, error: error.message, isLoading: false }));
    }
    console.error(`Error fetching data from ${endpoint}:`, error);
    throw new Error(`Failed to fetch data from ${endpoint}`);
  }
};

export const atsJobsApiActions = (actionId, config = {}) => {
  // note: to use params, pass it directly inside requestConfig like below
  // requestConfig: { params: queryParams }
  const currentAction = actionsConfig[actionId];
  const { isApi } = config;
  if (!currentAction)
    return console.error('no actions config found for ats jobs');

  const { endpoint, thunkName } = currentAction;

  if (isApi) {
    return (...args) => {
      return apiAction({ ...currentAction, endpoint }, config, args);
    };
  }

  return (...args) => {
    return createAsyncThunk(
      thunkName,
      apiAction({ ...currentAction, endpoint }, config, args)
    );
  };
};
